// extracted by mini-css-extract-plugin
export default {"wrapper":"DemoPlaceholder_wrapper__tYttD","icon":"DemoPlaceholder_icon__hB+8S","label":"DemoPlaceholder_label__z6U8x"};